import React, { useState, Fragment, useEffect } from 'react'
import clsx from 'clsx'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import CssBaseline from '@material-ui/core/CssBaseline'
import {
  Grid,
  Snackbar,
  Avatar,
  Box,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  Container,
  Badge,
  SwipeableDrawer
} from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import MenuIcon from '@material-ui/icons/Menu'
//import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import CloseIcon from '@material-ui/icons/Close'
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'
import {
  MainListItems,
  SecondaryListItems,
  UserItem,
  PublicList,
  DeliveryList,
  ChefList,
} from './listItemsMenu'
import { Link } from '@reach/router'
import burgerIcon from '../../img/LOGO_BLANCO.png'
import Context from '../../context/mainContext'
import WhatsappButtonWithData from '../../containers/whatsappButtonWithData'
import DeliveryWalletWithData from '../../containers/deliveryWalletWithData'
import PendingOrdersWithData from '../../containers/pendingOrdersWithData'
import UserIncompleteNotificationWithData from '../../containers/userIncompleteNotificationWithData'
import { getClientPointsRealTime } from '../../firebase/obj/client'
import Footer from '../footer'
import { useStyles } from './styles'
import PushNotificationContainer from '../../containers/pushNotification'
import { checkBrowserCompatibility } from '../../utils'
import AlertDialog from '../dialog'
import useMainContext from '../../hooks/useMainContext'
import PhoneValidationwithData from '../../containers/phoneValidationwithData'
import SearchInput from '../searchInput'

function Alert(props) {
  return <MuiAlert elevation={1} {...props} />
}

export const Layout = ({ children, user, isDelivery }) => {
  const classes = useStyles()
  const theme = useTheme()
  //const matches = useMediaQuery(theme.breakpoints.up('sm'))
  const [open, setOpen] = useState(false)
  const [online, setOnline] = useState(true)
  //const [drawerType, setDrawerType] = useState('permanent')
  const [rootClassName, setRootClassName] = useState(classes.permanent)
  const [clientPoints, setClientPoints] = useState(0)
  const [browserNoCompatible, setBrowserNoCompatible] = useState(false)
  const { layoutContainerRef, showFooter } = useMainContext()


  const toggleDrawer = (open) => (event) => {
    //console.log('SwipeableTemporaryDrawer open', open)
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setOpen(open)
  }

  useEffect(() => {
    if (user)
      return getClientPointsRealTime(user.uid, setClientPoints)
  }, [user])

  useEffect(() => {
    if (!checkBrowserCompatibility())
      setBrowserNoCompatible(true)
  }, [])

  /* const setClassRoot = (_open) => {
    if (_open) {
      setRootClassName(classes.permanent)
    } else {
      matches ? setRootClassName(classes.permanent) : setRootClassName(classes.persistent)
    }

  }

  useEffect(() => {
    matches ? setDrawerType('permanent') : setDrawerType('persistent')
    setClassRoot(open)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches, open]) */

  const handleDrawerOpen = () => {
    setOpen(true)
    //setClassRoot(true)
  }
  const handleDrawerClose = () => {
    setOpen(false)
    //setClassRoot(false)
  }
  //const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  const handleOnlineClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOnline(false);
  }

  window.addEventListener('load', () => {
    // 1st, we set the correct status when the page loads
    navigator.onLine ? setOnline(true) : setOnline(false);

    // now we listen for network status changes
    window.addEventListener('online', () => {
      setOnline(true);
    })

    window.addEventListener('offline', () => {
      setOnline(false);
    })
  })

  const accessList = (isAdmin, isChef, isDelivery) => {
    if (isAdmin)
      return (
        <React.Fragment>
          <List><MainListItems setOpen={setOpen} /></List>
          <Divider />
          <List><SecondaryListItems setOpen={setOpen} /></List>
          <Divider />
        </React.Fragment>
      )
    else if (isChef)
      return (
        <List><ChefList setOpen={setOpen} /></List>
      )
    else if (isDelivery)
      return (
        <List><DeliveryList setOpen={setOpen} /></List>
      )
    else
      return (
        <List><PublicList setOpen={setOpen} /></List>
      )
  }

  return (
    <div className={rootClassName}>
      <Snackbar open={!online} className={classes.snackbar} variant="outlined" onClose={handleOnlineClose}>
        <Alert severity={'info'} className={classes.onlineAlert}>
          {'Sin conexíon a internet'}
        </Alert>
      </Snackbar>
      <CssBaseline />
      <AppBar position="absolute" className={clsx(classes.appBar)}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton)}
          >
            <MenuIcon />
          </IconButton>
          <Grid container direction="row" justify="space-between" alignItems="center">
            <Grid item xs={2} sm={4}>
              <Link to='/' className={classes.linkAvatar} >
                <Avatar alt="Burgerhouse" variant="square" src={burgerIcon} className={classes.large} />
                <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                  {' '}
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={6} sm={4} container alignContent='center' >
              <SearchInput />
            </Grid>
            <Grid item xs={4} sm={4} container alignContent='center' direction="row-reverse">
              <Context.Consumer>
                {
                  ({ isAdmin, isDelivery, cart, isAuth }) =>
                    isAdmin ?
                      <>
                        <Link to='/newOrder' className={classes.linkRouter}>
                          <IconButton color="inherit">
                            <Typography>Nuevo pedido</Typography>
                          </IconButton>
                        </Link>
                      </>
                      :
                      isDelivery ? <Fragment>
                        <PendingOrdersWithData />
                        <DeliveryWalletWithData />
                      </Fragment>
                        :
                        <Grid item container alignItems='center' justify="flex-end" spacing={1}>
                          {
                            isAuth && <Grid item xs={8} md={6} lg={4}>
                              <Typography>{clientPoints} puntos</Typography>
                            </Grid>
                          }
                          <Grid item xs={2} md={2}>
                            <Link to='/carrito' className={classes.linkRouter}>
                              <Badge badgeContent={cart.totalQty || 0} color="secondary">
                                <ShoppingBasketIcon />
                              </Badge>
                            </Link>
                          </Grid>
                        </Grid>

                }
              </Context.Consumer>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <SwipeableDrawer
        anchor={'left'}
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        className={classes.swipeableDrawer}
        classes={{
          paper: classes.swipeableDrawerPaper
        }}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <Divider />
        <Context.Consumer>
          {
            ({ isAdmin, isDelivery, isChef }) =>
              accessList(isAdmin, isChef, isDelivery)
          }
        </Context.Consumer>

        <List><UserItem setOpen={setOpen} /></List>
      </SwipeableDrawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container ref={layoutContainerRef} maxWidth={false} className={classes.container}>
          {children}
          <AlertDialog
            open={browserNoCompatible}
            disableBackdropClick={true}
            fullWidth
            acceptText={null}
            cancelText={null}
            message="Este navegador no es compatible con la aplicación"
          >
            <Typography paragraph={true}>Por favor, utilice uno de los siguientes navegadores para disfrutar de una experiencia completa.</Typography>
            <Typography>Chrome</Typography>
            <Typography>Safari</Typography>
            <Typography>Edge</Typography>
            <Typography>Firefox</Typography>
          </AlertDialog>
          <Context.Consumer>
            {
              ({ isAdmin, isDelivery, isChef, user }) =>
                (!isAdmin && !isDelivery && !isChef) &&
                <Fragment>
                  <WhatsappButtonWithData />
                  {/* {
                    user && <UserIncompleteNotificationWithData user={user} />
                  } */}
                </Fragment>
            }
          </Context.Consumer>
          <PhoneValidationwithData />
          {
            (showFooter) &&
            <Box pt={4}>
              <Footer />
            </Box>
          }

        </Container>
      </main>
      {
        isDelivery && <PushNotificationContainer user={user} topic={user.email} />
      }
    </div>
  )
}

export default Layout